/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdatePaymentDto
 */
export interface CreateUpdatePaymentDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePaymentDto
     */
    provider?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePaymentDto
     */
    amount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePaymentDto
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePaymentDto
     */
    mail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePaymentDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePaymentDto
     */
    visitId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePaymentDto
     */
    returnUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdatePaymentDto
     */
    isSellDocumentIssued?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePaymentDto
     */
    invoicePaymentId?: string | null;
}

/**
 * Check if a given object implements the CreateUpdatePaymentDto interface.
 */
export function instanceOfCreateUpdatePaymentDto(value: object): value is CreateUpdatePaymentDto {
    return true;
}

export function CreateUpdatePaymentDtoFromJSON(json: any): CreateUpdatePaymentDto {
    return CreateUpdatePaymentDtoFromJSONTyped(json, false);
}

export function CreateUpdatePaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdatePaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'provider': json['provider'] == null ? undefined : json['provider'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'mail': json['mail'] == null ? undefined : json['mail'],
        'description': json['description'] == null ? undefined : json['description'],
        'visitId': json['visitId'] == null ? undefined : json['visitId'],
        'returnUrl': json['returnUrl'] == null ? undefined : json['returnUrl'],
        'isSellDocumentIssued': json['isSellDocumentIssued'] == null ? undefined : json['isSellDocumentIssued'],
        'invoicePaymentId': json['invoicePaymentId'] == null ? undefined : json['invoicePaymentId'],
    };
}

export function CreateUpdatePaymentDtoToJSON(value?: CreateUpdatePaymentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'provider': value['provider'],
        'amount': value['amount'],
        'currency': value['currency'],
        'mail': value['mail'],
        'description': value['description'],
        'visitId': value['visitId'],
        'returnUrl': value['returnUrl'],
        'isSellDocumentIssued': value['isSellDocumentIssued'],
        'invoicePaymentId': value['invoicePaymentId'],
    };
}

